const formatPattern = (url, params) => {
    if (!params || !url) {
        console.error('[formatPattern] Error: One or more of required args is missing!');
    }
    let replacedUrl = url;

    Object.keys(params).map(key => {
        replacedUrl = replacedUrl.replace(`:${key}`, encodeURIComponent(params[key]));
    });
    return replacedUrl;
};

export { formatPattern };
